import { render } from "./Calendar.vue?vue&type=template&id=5d45e800&scoped=true"
import script from "./Calendar.vue?vue&type=script&lang=js"
export * from "./Calendar.vue?vue&type=script&lang=js"

import "./Calendar.vue?vue&type=style&index=0&id=5d45e800&lang=css"
import "./Calendar.vue?vue&type=style&index=1&id=5d45e800&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d45e800"]])

export default __exports__